export default {
    common: {
        add: "Add",
        update: "Update",
        delete: "Delete"
    },
    claims: {
        api_login: "API Login",
        audit: "Audit",
        code_activity: "Code Activity",
        commission_report: "Commission Report",
        custom_fields: "Custom Fields",
        disable_apu: "Disable APU",
        driver_code: "Driver Code",
        events: "Events",
        excluded_columns: "Excluded Columns",
        file_archive_data: "File Archive Data",
        firmware: "Firmware",
        kiosks: "Kiosks",
        kiosk_configuration: "Kiosk Configuration",
        kiosk_details: "Kiosk Details",
        kiosk_diagnostic_maintenance: "Kiosk Diagnostic Maintenance",
        kiosk_extended_details: "Kiosk Extended Details",
        kiosk_inventory: "Kiosk Inventory",
        kiosk_issues: "Kiosk Issues",
        kiosk_qrcode: "Kiosk QR Code",
        kiosk_trust: "Kiosk Trust",
        log_data: "Log Data",
        maintenance_logs: "Maintenance Logs",
        parts_request: "Parts Request",
        password: "Password",
        phase: "Phase",
        prices: "Prices",
        problems: "Problems",
        products: "Products",
        promo_free: "Promo Free",
        portal_configuration: "Portal Configuration",
        portal_images: "Portal Images",
        refunds: "Refunds",
        regions: "Regions",
        remote_access: "Remote Access",
        remote_access_remote_ts: "Remote Access Remote Ts",
        remote_access_rvnc: "Remote Access Rvnc",
        remote_access_vnc: "Remote Access Vnc",
        requires_two_fa: "Requires Two FA",
        role: "Role",
        sales: "Sales",
        servant: "Servants",
        software: "Software",
        stores: "Stores",
        tags: "Tags",
        technician: "Technician",
        transactions: "Transactions",
        transaction_logs: "Transaction Logs",
        uptime: "Uptime",
        user: "User",
        promo_single: "Promo Single Use",
        promo_multiple: "Promo Multiple Use",
        promo_program: "Promo Programs",
        promo_reimbursement: "Promo Reimbursement",
        promo_transactioncodes: "Promo Transaction Codes"
    }
}